import {default as defaultConfig } from './local.json';
import {default as prodConfig } from './prod.json';
import { version } from '@root/package.json';

const environment = {...{version}, ...defaultConfig, ...prodConfig};

export default environment;
